var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"cart-list-wrap\"><cart item-entry=\"true\" use-quick-view=\"true\" hide-heading=\"true\"></cart></div>";
var id1="order-details-lines.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;